import React from 'react';
import { Text as ShrikeText } from '@perch-labs/shrike';
import { Text } from 'styles';
import { StyledMovingDetail } from './review-new-home.style';

interface Props {
  label: string;
  text?: string | null;
}

export const MovingDetail = ({ label, text }: Props) => {
  return (
    <StyledMovingDetail>
      <ShrikeText tag="h2" textStyle="heading500">
        {label}
      </ShrikeText>
      <Text margin={{ top: '8px' }}>{text}</Text>
    </StyledMovingDetail>
  );
};
